import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { Button } from "reactstrap";
import { PaymentInputsWrapper, usePaymentInputs } from "react-payment-inputs";
import base_url from "../../api/bootapi";
import axios from "axios";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";
import images from "react-payment-inputs/images";
import "./PaymentModal.css";
import cancel from "../../assets/close.png";

const PaymentModal = ({
  totalPrice,
  enquiryData,
  isOpen,
  onRequestClose,
  amount,
  setAmount,
  enquiry_id,
  jwtToken,
  setbackdropopen,
  fetchEnquiryData,
}) => {
  const customStylesone = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      border: "none",
      padding: "28px 36px"
    },
    overlay: {
      zIndex: 9,
      backdropFilter: "blur(4px)",
      backgroundColor: 'rgba(0, 0, 0, 0.1)'
    }
  };

  const {
    wrapperProps,
    getCardImageProps,
    getCardNumberProps,
    getExpiryDateProps,
    getCVCProps,
  } = usePaymentInputs();

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm();
  // const [accommodation, setAccommodation] = useState("0");
  // const [error, setError] = useState("");
  const [amountWithOutCharges, setAmountWithOutCharges] = useState(0);
  const [cardCharges, setCardCharges] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("Card");


  const [newAmountWithoutCharges, setNewAmountWithoutCharges] = useState(0);
  const [newCardCharges, setNewCardCharges] = useState(3);

 useEffect(() => {
  if (Number(amount) > 0) {
    const amt = Number(amount) || 0;

    const charges = (amt * newCardCharges) / 100;      // 3% charges
    const total = amt + charges;          // amount + charges

    setNewCardCharges(charges);
    setNewAmountWithoutCharges(Number(total).toFixed(2));
  } else {

    setNewAmountWithoutCharges(0);
  }
}, [amount]);

  const handlePaymentMethodChange = (e) => {
    let newAmount = amountWithOutCharges;
    if (e.target.value == "Card") {
      newAmount = (Number(amountWithOutCharges) + Number(cardCharges)).toFixed(2);
    }

    setAmount(newAmount);
    setPaymentMethod(e.target.value);
  };

  const [cardDetails, setCardDetails] = useState({
    card_number: null,
    card_expiry_month: null,
    card_expiry_year: null,
    card_cvv: null,
  });

  // useEffect(() => {
  //   setAccommodation(enquiryData.accommodation_only_price);
  // }, [enquiryData.accommodation_only_price])


  // useEffect(() => {
  //   if (!enquiryData.tour_id || cardCharges != null) return;

  //   setAmountWithOutCharges(amount);
  //   axios
  //     .get(`${base_url.api1}/tourapp/get_trip?id=${enquiryData.tour_id}`)
  //     .then((response) => {
  //       const cardChargePercent = 3;
  //       const tourAccommodationPrice = response.data.Tour[0].accommodation_only_price;
  //       const accommodation = enquiryData.accommodation_only_price;
  //       let cardcharges = 0;

  //       if (Number(tourAccommodationPrice) == Number(accommodation)) {
  //         cardcharges = ((tourAccommodationPrice) * (cardChargePercent / 100));
  //       } 
        
  //       setCardCharges(cardcharges);
  //     })
  //     .catch((err) => { 
  //       setCardCharges(0);
  //     });
  // }, [enquiryData]);

  const handleAmountChange = (e) => {
    let value = e.target.value;

    value = value.replace(/[^0-9.]/g, "");

    const decimalIndex = value.indexOf(".");
    if (decimalIndex !== -1) {
      value =
        value.substring(0, decimalIndex + 1) +
        value.substring(decimalIndex + 1).replace(/\./g, "");
    }

    // let newAmount = 0;
    // newAmount += enquiryData.full_package ? Number(enquiryData.full_package_price) : 0;
    // newAmount += enquiryData.insurance ? Number(enquiryData.insurance_price) : 0;
    // newAmount += Number(value);

    // setAmount(newAmount);
    // setAccommodation(value);

    setAmount(value);
  };

  const handleChangeCardNumber = (e) => {
    setCardDetails({
      ...cardDetails,
      card_number: e.target.value,
    });
  };

  const handleChangeExpiryDate = (e) => {
    setCardDetails({
      ...cardDetails,
      card_expiry_year: e.target.value,
    });
  };

  const handleChangeCVC = (e) => {
    setCardDetails({
      ...cardDetails,
      card_cvv: e.target.value,
    });
  };

  const onSubmit = (data) => {
    // if (enquiryData.accommodation_only) {
    //   if (Number(accommodation) <= 0) {
    //     setError("Accommodation is required");
    //     return;
    //   } else if (Number(accommodation) < 500) {
    //     setError("Minimum $500 Accommodation is required");
    //     return;
    //   }
    // }
    // setError("");
    if (Number(newAmountWithoutCharges) <= 0) {
      return;
    }
    const formData = new FormData();
    let submitData = {};

    if (paymentMethod === "Card") {
      submitData = {
        card_expiry_month: cardDetails.card_expiry_year.substring(0, 2),
        card_expiry_year: cardDetails.card_expiry_year.substring(5, 7),
        card_number: cardDetails.card_number,
        card_cvv: cardDetails.card_cvv,
      };
    }

    if (paymentMethod === "Check" || paymentMethod === "Zelle") {
      submitData.transaction_id = data.transaction_id;
    }
    submitData.amount = Number(newAmountWithoutCharges);
    submitData.payment_method = paymentMethod;

    formData.append("data", JSON.stringify(submitData));
    let id;

    if (enquiry_id?.includes('_')) {
      id=enquiry_id?.split('_')?.[0]
    } else {
      id= enquiry_id
    }
    setbackdropopen(true);
    axios
      .post(
        `${base_url.api1}/tourapp/make_payment?id=` + id,
        formData,
        {
          headers: {
            Authorization: jwtToken,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            setbackdropopen(false);
            onRequestClose();
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Payment Successful",
              showCloseButton: true,
              showConfirmButton: false,
            });
            fetchEnquiryData();
          } else {
            setbackdropopen(false);
            onRequestClose();
            Swal.fire({
              position: "center",
              icon: "error",
              title: "Payment failed",
              showCloseButton: true,
              showConfirmButton: false,
            });
          }
        },
        (error) => {
          setbackdropopen(false);
          onRequestClose();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            showConfirmButton: false,
            showCloseButton: true,
          });
        }
      );
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStylesone}
      contentLabel="Payment Modal"
    >
    <div className="payment_modal">
      <p className="card_head">Payment Details</p>

      <form onSubmit={handleSubmit(onSubmit)} id="myForm">
        <div>
          <div className="form-group creatadmin">
            {/* Payment Method Selection */}
            <div className="form-group">
              <label htmlFor="paymentMethod">Payment Method</label>
              <select
                id="paymentMethod"
                value={paymentMethod}
                onChange={handlePaymentMethodChange}
                className="form-control"
              >
                {/* <option value="Cash">Cash</option> */}
                <option value="Card">Card</option>
                {/* <option value="Check">Check</option>
                <option value="Zelle">Zelle</option> */}
              </select>
            </div>

            {/* Amount Input */}
            <div className="form-group" style={{ marginTop: "15px" }}>
              <label htmlFor="amount">
                Amount(in $)<span style={{ color: "red" }}>*</span>:
              </label>
              <input
                type="text"
                id="amount"
                value={newAmountWithoutCharges}
                onChange={handleAmountChange}
                className="form-control"
                placeholder="Enter amount"
                  required
                  readOnly
              />
              </div>
              
              <p style={{ color:"red",margin:"0px"}}>3% charge added in open balance</p>

            {paymentMethod === "Check" && (
              <div className="form-group" style={{ marginTop: "15px" }}>
                <label htmlFor="amount">
                  Check No.<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Check No."
                  name="transaction_id"
                  {...register("transaction_id", {
                    required: true,
                  })}
                />
                {errors.transaction_id && (
                  <p className="errormessage">Check No. is Required</p>
                )}
              </div>
            )}

            {paymentMethod === "Zelle" && (
              <div className="form-group" style={{ marginTop: "15px" }}>
                <label htmlFor="amount">
                  Transaction ID<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Transaction ID"
                  name="transaction_id"
                  {...register("transaction_id", {
                    required: true,
                  })}
                />
                {errors.transaction_id && (
                  <p className="errormessage">Transcation ID is Required</p>
                )}
              </div>
            )}

            {/* Card Payment Details - Only show when the payment method is "Card" */}
            {paymentMethod === "Card" && (
              <PaymentInputsWrapper
                {...wrapperProps}
                styles={{
                  fieldWrapper: {
                    base: "margin-bottom: 0; min-height: 2.5rem; margin-top:1rem",
                  },
                  inputWrapper: {
                    base: "height: 100%; display:flex; flex-direction:column; gap:1rem; border:none; box-shadow:none; padding: 0",
                    errored: "border:none; box-shadow:none",
                    focused: "border:none; box-shadow:none",
                  },
                  input: {
                    cardNumber: "padding: 5px; text-align:center; width: 18rem",
                    expiryDate: "padding: 5px; text-align:center; width: 12rem",
                    cvc: "padding: 5px; text-align:center; width: 8rem",
                  },
                }}
              >
                <div>
                  <label>Debit/Credit</label>
                  <div className="input_card">
                    <input
                      required
                      {...getCardNumberProps({
                        onChange: handleChangeCardNumber,
                      })}
                    />
                    <svg {...getCardImageProps({ images })} />
                  </div>
                </div>

                <div className="card_bottom">
                  <div>
                    <label>Expire Date</label>
                    <div className="input_card">
                      <input
                        required
                        {...getExpiryDateProps({
                          onChange: handleChangeExpiryDate,
                        })}
                      />
                    </div>
                  </div>
                  <div>
                    <label>CVV</label>
                      <div className="input_card">
                      <input 
                        required
                        {...getCVCProps({
                          onChange: handleChangeCVC,
                        })}
                      />
                      </div>
                  </div>
                </div>
              </PaymentInputsWrapper>
            )}
          </div>
          <br />
          <div
            style={{
              display: "flex",
              gap: "12px",
              justifyContent: "flex-end"
            }}
          >
            <Button
              type="button"
              onClick={onRequestClose}
              className="btn"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              color="primary"
              className="btn btn-primary"
            >
              Pay Now
            </Button>
          </div>
        </div>
        </form>
      </div>
    </Modal>
  );
};

export default PaymentModal;
